import Homepage from "../components/Homepage";
import Pendulum from "../components/Pendulum";
import Questionone from "../components/questions/Questionone";
import VideoComponent from "../components/VideoComponent";
import { paths } from "./path";


export const routes = [
    {
        name: "Homepage",
        path: paths.homepage,
        exact: true,
        element: <Homepage />,
    },
    {
        name: "Pendulum",
        path: paths.pendulum,
        exact: true,
        element: <Pendulum />,
    },
    {
        name: "VideoComponent",
        path: paths.video,
        exact: true,
        element: <VideoComponent />,
    },
    {
        name: "Questionone",
        path: paths.questionone,
        exact: true,
        element: <Questionone />,
    },
];